import type { SVGProps } from 'react';
const DawnFlagTT = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-TT_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-TT_svg__a)">
      <path fill="#ED233C" d="M0 0h22v16H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M16.083 20.336-.049.761l5.967-5.097L22.05 15.239z"
        clipRule="evenodd"
      />
      <path
        fill="#262626"
        fillRule="evenodd"
        d="M18.758 21.562-.771-2.134l4.013-3.428L22.77 18.134z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagTT;
